import { render, staticRenderFns } from "./FormMultipleFile.vue?vue&type=template&id=84d14080"
import script from "./FormMultipleFile.vue?vue&type=script&lang=js"
export * from "./FormMultipleFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports